module.exports = __webpack_public_path__ + "img/levelnull.70c3a6c4.svg";